module.exports = __webpack_public_path__ + "static/media/Download.12b8db9b.svg";